import { createClient } from "@connectrpc/connect";
import { IDeleteService } from "../../../../abstractions/services/actions/IDeleteService";
import { grpcTransportProvider } from "../../../../comun/services/grpc/GrpcTransport";
import { mapConnectError } from "../../../../comun/services/grpc/mapConnectError";
import { CompraAnimalesService } from "../../../../generated/grpc/pesaje_ganaderia_pb";
import { grpcCompraAnimalesDatabase } from "../database/GrpcCompraAnimalesDatabase";
import { CompraAnimalesResponse } from "../response/CompraAnimalesResponse";
import { fx_aplicarCambiosMovimientoAsync } from "./aplicarCambiosMovimiento";

/** Variante gRPC-Web de `CompraAnimalesDeleteService` (ver ese archivo).
 *  `deleteOneAsync` la saca de `GrpcCompraAnimalesDatabase` y
 *  `fx_aplicarCambiosMovimientoAsync` escribe lo que el server cambió aparte,
 *  que viene en la respuesta (2026-10-08): el potrero recalculado y las
 *  compras que quedan, con los códigos renumerados. */
export class CompraAnimalesDeleteGrpcService
  implements IDeleteService<CompraAnimalesResponse>
{
  async deleteAsync(item: CompraAnimalesResponse): Promise<void> {
    const client = createClient(CompraAnimalesService, grpcTransportProvider.get());

    let respuesta;
    try {
      respuesta = await client.eliminar({ id: item.id });
    } catch (error) {
      throw mapConnectError(error);
    }

    await grpcCompraAnimalesDatabase.deleteOneAsync(item.id);
    await fx_aplicarCambiosMovimientoAsync(respuesta);
  }
}
